<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <!-- <nav-bar></nav-bar> -->
  <router-view></router-view>
  <!-- <bottom-footer></bottom-footer> -->
</template>

<script>
// import NavBar from "./components/NavBar.vue";
// import BottomFooter from "./components/BottomFooter.vue";
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: "App",
  components: {
    // NavBar,
    // BottomFooter,
    // HelloWorld
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
